export default __webpack_public_path__ + "static/media/cont2.f5debeac.jpg";